module.exports = __webpack_public_path__ + "static/media/boardfolio-steps-tc.a7d343a9.png";